export const SET_STORES_FILTERS = 'SET_STORES_FILTERS';

export const setStoresFilters = ({ search = '', enabled = '', type = [], from_created = '', to_created = '' } = {}) => ({
    type: SET_STORES_FILTERS,
    payload: {
        search,
        enabled,
        type,
        from_created,
        to_created
    }
});
